import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { useStores } from '../../../hooks';
import { GiftItem } from './components';

import styles from './styles/gift_cabinet.module.scss';

export const GiftCabinet = observer(() => {
  const { loyaltyStore } = useStores();

  const { getGifts, gifts } = loyaltyStore;

  useEffect(() => {
    (async () => {
      await getGifts();
    })();
  }, []);

  return (
    <div className={styles.gift_cabinet}>
      {gifts.map((gift) => (
        <GiftItem key={gift.id} gift={gift} />
      ))}
    </div>
  );
});
